import React, { Component, useContext, useEffect, useState, useCallback, useRef } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as updateConfigurationActions from '../../../actions/updateConfigurationActions';
import * as uiActions from '../../../actions/uiActions';
import { ModalButton } from '../../../components/ModalButton';
import { TranslationContext } from "../../../context/TranslationContext";
import { InputNumber } from '../../../components/InputNumber';
import PropTypes from 'prop-types';
import CustomInputNumber from '../../../components/CustomInputNumber';
import * as _ from 'lodash';
import { getMonumentDataAPI, getMonumentData, validateMonumentData, getProductInfoAPI, sanitizeLayoutDataResp, sanitizePositionsAndGroupId } from '../../helpers/customPartHelper';
import {
  fetchDataWarning,
  saveDataWarning
} from '../../../services/configurationWarningChecks';

export class CustomPartsComponent extends Component {
  static contextType = TranslationContext;
  static propTypes = {
    isOpen: PropTypes.bool,
  };

  handleCloseModal = () => {
    if (this.props.onClose) {
      fetchDataWarning(false);
      saveDataWarning(false);
      this.props.onClose();
    }
  };

  render() {
    const t = this.context;
    const additionalInfo = ""
    const { disabled, layout, availablesLayouts } = this.props;
    return (
      <div className="btn-wrapper">
        <ModalButton
          openModal={this.props.isOpen}
          onModalClose={this.handleCloseModal}
          buttonContent="Détails"
          buttonIcon="finalization-icon"
          className={'ConfigurationDetailsPopupModal ' + (disabled ? 'disabled' : '')}
          disabled={disabled}
          overlayClassName="ConfigurationDetailsPopupModalOverlay"
          additionalInfo={additionalInfo}
          // toggleSteps={this.props.toggleSteps}
          // launchIntro={this.props.launchIntro}
          // modalName={this.props.modalName}
          buttonClassName={`btn-config-secondary text-dark background-page ${!disabled && 'secondary3-hover text-dark-border'} `}>
          <ModalConfigurationDescription onModalClose={this.handleCloseModal} onValidate={this.props.onValidate}
            deformable={this.props.deformable}  toggleSteps={this.props.toggleSteps}
            launchIntro={this.props.launchIntro}/>
        </ModalButton>
      </div>
    );
  }
}
export const CustomParts = connect()(CustomPartsComponent);

function ModalConfigurationDescriptionComponent(props) {
  const t = useContext(TranslationContext);
  
  const { layouts, monumentLayout, deformableUpdateSuccess } = props;
  const availablesLayouts = layouts.filter(layout => layout.available);
  const [selectedLayout, setSelectedLayout] = useState(monumentLayout);
  const [monumentData, setMonumentData] = useState(null);
  const [layoutData, setLayoutData] = useState(null);
  const [productId, setProductId] = useState(props?.configurator?.current?.configuration?.monument?.productId || null);
  const [imageSvg, setImageSvg] = useState(null);
  const layout = layouts.find(
    layout => layout.reference === monumentLayout
  );

  let layoutWidthValue = layout?.size.width;
  let layoutHeightValue = layout?.size.depth;

  const [openSection, setOpenSection] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [step, setStep] = useState(1);
  const [loadIcon, setLoadIcon] = useState(false);
  const [loadValidIcon, setLoadValidIcon] = useState(false);
  const [LoadIconFirstStep, setLoadIconFirstStep] = useState(true);
  const [loadIconSecondStep, setLoadIconSecondStep] = useState(false);
  const [productInforror, setErrorProductInfo] = useState(false);
  const [productConfigError, setErrorProductConfig] = useState(false);

  const toggle = (section) => {
    setOpenSection(openSection === section ? null : section);

    loadImageSvg(section, monumentData?.combinations?.[0]?.imageSVG);
  };

  const loadImageSvg = (section, baseImageSVG) => {
    if (baseImageSVG && section) {
      // parse the SVG string to a DOM object
      const parser = new DOMParser();
      const svgDoc = parser.parseFromString(baseImageSVG, "image/svg+xml");
      // find the element with the given section id
      const elements = svgDoc.querySelectorAll(`#${section}`);
      elements.forEach(el => {
        el.setAttribute("fill", props.ui?.highlightSchemeColor || "#9c9898ff"); // change color to red
      });
      // serialize the DOM object back to a string
      const serializer = new XMLSerializer();
      const updatedSVGString = serializer.serializeToString(svgDoc);
      setImageSvg(updatedSVGString);
    } else if (baseImageSVG) {
      setImageSvg(baseImageSVG);
    }
  }
  
  const monumentDataRef = useRef(monumentData);
  
  useEffect(() => {
    const fetchInitialData = async () => {
      let layoutValue = selectedLayout;
      if (!selectedLayout || selectedLayout === "") {
        if (productId && productId.charAt(0) >= '0' && productId.charAt(0) <= '9') {
          layoutValue = productId.slice(0, 2);
        } else {
          layoutValue = productId.charAt(0);
        }
      }
      const newProductId = changeProductId(layoutValue);
      setProductId(newProductId);
      try {
        setErrorProductConfig(false)
        const deformable = props.configurator?.current?.configuration?.deformable;
        const isDeformable = deformable?.layout || deformable?.baseHeight;
        if (isDeformable) {
          setLoadIconSecondStep(true);
          const monumentDataResp = await getMonumentData(props.configurator?.current?.configuration?.reference);

          if (monumentDataResp) {
            const firstElementKey = monumentDataResp.groups[0]?.groupId;
            setMonumentData(monumentDataResp);
            monumentDataRef.current = monumentDataResp;
            const layout = monumentDataResp.layout;
            setLayoutData(layout);
            setLoadIconFirstStep(false);
            setSelectedLayout(layout.code);
            setStep(2);
            setLoadIconSecondStep(false);
            setDisabled(false);
            setOpenSection(firstElementKey);
            loadImageSvg(firstElementKey, monumentDataResp.combinations?.[0]?.imageSVG);
          } else {
            await layoutDatas(newProductId);
          }
        } else {
          await layoutDatas(newProductId);
        }
      } catch (error) {
        await layoutDatas(newProductId);
        console.error("Error fetching initial monument data:", error);
      }
    };

    fetchInitialData();
  }, []);

  useEffect(() => {
    if (deformableUpdateSuccess) {
      setTimeout(() => {
        setLoadValidIcon(false);
        props.onValidate();
        props.onModalClose();
        
        // Reset the flag
        props.actions.resetDeformableSuccess();
      }, 300);
    }
  }, [deformableUpdateSuccess]);

  const layoutWidth = layoutData?.dimensions?.width;
  const layoutHeight = layoutData?.dimensions?.depth;
  const layoutPieces = async () => {
    setLoadIcon(true);
    setLoadIconSecondStep(true);
    setErrorProductConfig(false);
    fetchDataWarning(false);
    try {
      layoutWidthValue = layoutWidth?.userValue;
      layoutHeightValue = layoutHeight?.userValue;
      const monumentDataResp = await getMonumentDataAPI(productId, layoutWidthValue, layoutHeightValue);
      if (monumentDataResp) {
        const firstElementKey = monumentDataResp.groups[0]?.groupId;
        setMonumentData(monumentDataResp);
        monumentDataRef.current = monumentDataResp;
        setLoadIcon(false);
        setDisabled(false);
        setStep(2);
        setLoadIconSecondStep(false);
        setOpenSection(firstElementKey);
        loadImageSvg(firstElementKey, monumentDataResp.combinations?.[0]?.imageSVG);

        setTimeout(() => {
          props.launchIntro(true, "CustomPartsModalInside");
        }, 100);
      }
    } catch (error) {
      setErrorProductConfig(true);
      setLoadIconSecondStep(false);
      console.error("Error fetching monument data:", error);
      setLoadIcon(false);
      if (error.message === "404") {
        fetchDataWarning(true, true);
      } else {
        fetchDataWarning();
      }
    }
  }

  const debounceHandleDimensionValueChange = (partIndex, fieldIndex, dimensionKey, newValue) => {
    const updatedMonumentData = { ...monumentDataRef.current };
    const partToUpdate = updatedMonumentData.groups[partIndex];
    const fieldToUpdate = partToUpdate.parts[fieldIndex];
    setMonumentData(prevState => {
      const updatedParts = [ ...prevState.groups ];
      const updatedDimensions = { ...fieldToUpdate.dimensions };
      const prevValue = updatedDimensions[dimensionKey].userValue;
      const delta = newValue - prevValue;

      // impact calcul
      updatedParts.forEach(part=>{ 
        part.parts.forEach(dimkey=>{
          let dimensionskey = dimkey.dimensions
          Object.keys(dimensionskey).forEach((dim,index) =>{
            // partKey !== key && index !== fieldIndex && dim !== dimensionKey &&
            if(dimensionskey[dim].id === updatedDimensions[dimensionKey].id && dimensionskey[dim].impact === 1){
              
              //test if newvalue is greater than max or less than min
              if(dimensionskey[dim].userValue + delta > dimensionskey[dim].max) {
                dimensionskey[dim].userValue = dimensionskey[dim].max;
              } else if(dimensionskey[dim].userValue + delta < dimensionskey[dim].min) {
                dimensionskey[dim].userValue = dimensionskey[dim].min;
              } else {
                dimensionskey[dim].userValue += delta;
              }
            }
        })
          
        })
      })
      // Set the new value
      if (fieldToUpdate.dimensions[dimensionKey]) {
        fieldToUpdate.dimensions[dimensionKey].userValue = newValue;
      }
      
      return {
        ...prevState,
        groups: updatedParts,
      };
    });
  }

  const debouncedHandleDimensionValueChange = useCallback(
    _.debounce((partIndex, fieldIndex, dimensionKey, newValue) => {
      debounceHandleDimensionValueChange(partIndex, fieldIndex, dimensionKey, newValue);
    }, 400), // debounce with 300ms delay
    []
  );

  // call debounced function
  const handleDimensionValueChange = (partIndex, fieldIndex, dimensionKey, newValue) => {
    debouncedHandleDimensionValueChange(partIndex, fieldIndex, dimensionKey, newValue);
  };

  const layoutDatas = async(productId) => {
    fetchDataWarning(false);
    setErrorProductInfo(false);
    try {
      setLoadIconSecondStep(false);
      const layoutDataResp = await getProductInfoAPI(productId);
      const sanitizedLayoutDataResp = sanitizeLayoutDataResp(layoutDataResp);
      if (sanitizedLayoutDataResp !== 0) {
        setLayoutData(sanitizedLayoutDataResp.layout);
        setLoadIconFirstStep(false)
        setImageSvg(sanitizedLayoutDataResp?.combinations?.[0]?.imageSVG);

        setTimeout(() => {
          props.launchIntro(true, "CustomPartsModal");
        }, 100);
      }
      
    } catch(error) {
      setErrorProductInfo(true);
      console.error("Error fetching product info:", error);
      setLoadIconFirstStep(false);

      if (error.message === "404") {
        fetchDataWarning(true, true);
        setLayoutData(null);
      } else {
        fetchDataWarning();
      }
    }
  }

  /*
    Change the productId based on the new layout and base height if needed (case MON)
    Ex: currentProductId : B412G05K12
    Ex: finded base height : 08
    Ex: new product id : B412G08K12
  */
  const getProductIdBaseHeight = (currentProductId, newLayout) => {
    const layoutsBaseHeight = props.layoutsBaseHeights.find(bh => bh.configuration === newLayout && bh.baseHeight && bh.baseHeight !== "00");

    if (layoutsBaseHeight) {
      return `${currentProductId.slice(0, -5)}${layoutsBaseHeight.baseHeight}${currentProductId.slice(-3)}`;
    }

    return currentProductId;
  }

  /*
    Change the productId based on the new layout and base height if needed (case TOMBALE)
    Ex: currentProductId : AT111A0505
    Ex: finded base height : can be "08" or "10/12"
    Ex: new product id : AT111A0808 or AT111A1012
  */
  const getProductIdBaseHeightTombale = (productIdOriginal, newLayout) => {
    const layoutsBaseHeight = props.layoutsBaseHeights.find(bh => bh.configuration === newLayout && bh.baseHeight && bh.baseHeight !== "00");

    if (layoutsBaseHeight) {
      const baseHeight = layoutsBaseHeight.baseHeight;
      if (baseHeight.length === 2) {
        return `${productIdOriginal.slice(0, -4)}${baseHeight}${baseHeight}`;
      } else if (baseHeight.length === 5 && baseHeight.includes('/')) {
        const [firstHeight, secondHeight] = baseHeight.split('/');
        return `${productIdOriginal.slice(0, -4)}${firstHeight}${secondHeight}`;
      }
    }

    return productIdOriginal;
  }

  const changeProductId = (newLayout) => {
    let currentProductId = props?.configurator?.current?.configuration?.monument?.productId;
    let {productIdOriginal, footstone} = props?.configurator?.current?.configuration?.monument;
    const headstoneRefToAdd = productIdOriginal.slice(-3);

    if (footstone && footstone.reference && footstone.reference.charAt(0) === 'T') {
      productIdOriginal = getProductIdBaseHeightTombale(productIdOriginal, newLayout);
      if (productIdOriginal && productIdOriginal.charAt(0) >= '0' && productIdOriginal.charAt(0) <= '9') {
        // change the first two characters with newLayout
        return newLayout + productIdOriginal.slice(2);
      } else {
        // change the first character with newLayout
        return newLayout + productIdOriginal.slice(1);
      }
    } else {
      currentProductId = getProductIdBaseHeight(currentProductId, newLayout);
      if (currentProductId && currentProductId.charAt(0) >= '0' && currentProductId.charAt(0) <= '9') {
        const newProductId = `${newLayout}${currentProductId.slice(2).slice(0, -3)}${headstoneRefToAdd}`;
        return newProductId;
      } else {
        const newProductId = `${newLayout}${currentProductId.slice(1).slice(0, -3)}${headstoneRefToAdd}`;
        return newProductId;
      }
    }
  }

  const handleLayoutValueChange = async (newValue)=>{
    setLoadIconFirstStep(true);
    const newLayout = availablesLayouts.find(l=>l.reference === newValue);
    const newProductId = changeProductId(newValue);
    setProductId(newProductId);
    setSelectedLayout(newLayout?.reference);
    await layoutDatas(newProductId);
  }

  const onChangeSteps = (e) => {
    setStep(parseInt(e.target.value));
    if (parseInt(e.target.value) === 1) {
      setDisabled(true);
    }
  }
  // const onChangelayoutWidth = (value) => {
  //   setLayoutWidth(value);
  // };
  const onChangelayoutDimensions = ( dimension, value) => {
    setLayoutData(prevState => {
      const updatedDimensions = { ...prevState.dimensions };
      updatedDimensions[dimension] = {
        ...updatedDimensions[dimension],
        userValue: value
      };
      return {
        ...prevState,
        dimensions: updatedDimensions
      };
    });

  };

  const handleValidate = async () => {
    try {
      saveDataWarning(false)
      setLoadValidIcon(true)
      const configRef = props.configurator?.current?.configuration?.reference;
      let newConfigDeformable = {...props.configDeformable};
      if(props.deformable) {
        if (props.deformable?.baseHeight) {
          newConfigDeformable.baseHeight = true;
          newConfigDeformable.layout = true;
        } else if (props.deformable?.layout){
          newConfigDeformable.layout = true;
          newConfigDeformable.baseHeight = true;
        }
      }
      
      const monData = {
        ...monumentData,
        configuration: configRef,
        deformable: newConfigDeformable,
      }
      const fmonData = sanitizePositionsAndGroupId(monData)
      
      const res = await validateMonumentData(fmonData);
      
      if (res && newConfigDeformable) {
        const layoutInfo = {width: fmonData.layout.dimensions.width.userValue, height: fmonData.layout.dimensions.depth.userValue}
        await props.actions.setDeformable(newConfigDeformable, productId, selectedLayout, layoutInfo);
      }
      
      
    } catch (error) {
      console.error("Error validating monument data:", error);
      saveDataWarning()
      setLoadValidIcon(false); // Don't forget to reset loading state on error
    }
  }
  

  return (
    <div className="CustomPartsModal">
      <div className="Header">
        <div className="HeaderContainer">
          <h1>{t("config3d_custom_pieces_modal_title")}</h1>
        </div>
      </div>

      <div className="CustomPartsContent">
        <div className="CustomPartsForm">
          <div className="FirstPart">
            <div className="FirstPartTitle">
              <label className="radio">
                <input type="radio" name="currentStep" className="radio-input" value="1" id="step1" checked={step === 1} onChange={(e) => onChangeSteps(e)} />
                <label className="radio-label" htmlFor="step1">
                  <span className="radio-border"></span>
                  {t("config3d_custom_pieces_modal_radio_step1")}
                </label>

              </label>
              <span className="title-layout">{layoutWidth && `${layoutWidth?.userValue} x ${layoutHeight?.userValue}`}</span>
            </div>
            <hr />
            { step === 1 && 
            <div className="FirstPartInputs" style={{}}>
              <div id="layoutSelect" className="CustomFormGroup">
                <label className="Label">
                  {t("config3d_custom_pieces_modal_select_layout")}
                </label>
                <div className="input-wrapper">
                  <select
                    className="custom-input-field"
                    value={selectedLayout}
                    onChange={(e) => handleLayoutValueChange(e.target.value)}
                  >
                    {availablesLayouts.map((l, index) => (
                      <option key={index} value={l.reference}>
                        {l.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              {/* {!LoadIconFirstStep && productInforror && 
                <div>
                  {fetchDataMessage}
                </div>
              } */}
              {LoadIconFirstStep && !productInforror && <div className="spinner-border first-step" role="status" />}

              {!LoadIconFirstStep && !productInforror &&
                <>
                  <div id="layoutWidth" className="CustomFormGroup">
                    <label className="Label">
                      {t("config3d_custom_pieces_modal_input_width")}
                    </label>
                    <div className="input-wrapper">
                      <InputNumber
                        className="custom-input-field"
                        min={layoutWidth?.min}
                        max={layoutWidth?.max}
                        custompart={true}
                        autoSelect={true} value={layoutWidth?.userValue} onValueChange={(value) => onChangelayoutDimensions("width", value)} />
                      <span className="custom-input-addon">
                        {t("config3d_custom_pieces_modal_input_unit")}
                      </span>
                    </div>
                    <div className="max-min-desc">{layoutWidth && <><span>Min : {layoutWidth?.min} </span><span>Max : {layoutWidth?.max}</span></>}</div>
                  </div>

                  <div id="layoutHeight" className="CustomFormGroup">
                    <label className="Label">
                      {t("config3d_custom_pieces_modal_input_depth")}
                    </label>
                    <div className="input-wrapper">
                      <InputNumber
                        className="custom-input-field"
                        min={layoutHeight?.min}
                        max={layoutHeight?.max}
                        custompart={true}
                        autoSelect={true} value={layoutHeight?.userValue} onValueChange={(value) => onChangelayoutDimensions("depth", value)} />
                      <span className="custom-input-addon">
                        {t("config3d_custom_pieces_modal_input_unit")}
                      </span>
                    </div>
                    <div className="max-min-desc">{layoutHeight && <><span>Min : {layoutHeight?.min} </span><span>Max : {layoutHeight?.max}</span></>}</div>
                  </div>

                  <div className="CustomFormGroup button">
                    {/*<label className="Label">
                      {t("config3d_custom_pieces_modal_input_validate")}
                    </label>
                    <button className="validate-button button-primary button-medium" onClick={layoutPieces}>
                      {loadIcon && <div className="spinner-border" role="status" />}
                      {!loadIcon && <span className="true-icon icon-large text-cta-icon"></span>}
                      <span>{t("config3d_custom_pieces_confirm_button") || "valider"}</span>

                    </button>*/}
                    <button id="layoutValidateButton"
                      className="validate-button button-primary button-medium text-cta float-right Order" onClick={layoutPieces}>
                      {loadIcon && <div className="spinner-border valid" role="status" />}
                      
                      <div>{t("config3d_custom_pieces_confirm_button") || "valider"}</div>
                    </button>
                  </div>
                </>
              }



            </div>
            }
          </div>

          <div className="SecondPart" style={{
            pointerEvents: disabled ? 'none' : 'auto',
            opacity: disabled ? 0.5 : 1,
          }}>
            <div className="SecondPartTitle">
              <label className="radio pt-0">
                <input type="radio" name="currentStep" className="radio-input" value="2" id="step2" checked={step === 2} onChange={(e) => onChangeSteps(e)} />
                <label className="radio-label" htmlFor="step2">
                  <span className="radio-border"></span>
                  {t("config3d_custom_pieces_modal_radio_step2")}
                </label>
              </label>
            </div>
            <div className="SecondPartInputs">
              <div className={loadIconSecondStep ? "border-top with-loader" : "border-top"} >
                {/* {!loadIconSecondStep && productConfigError && 
                  <div>
                    {fetchDataMessage}
                  </div>
                } */}
                {!loadIconSecondStep && !productConfigError && 
                  <>
                    {monumentData?.groups.map((part, index) => {
                      const partElements = part.parts;
                      const section = part.groupId;
                      const sectionName = part.groupName;
                      return (
                        <div key={index} className="border-bottom">
                          <div
                            className="coll-button d-block w-100 text-left pt-3 pb-1"
                            onClick={() => toggle(section)}
                          >
                            {sectionName}
                            <span className="float-right">
                              {openSection === section ? <span className="collapse-up-icon icon-large text-cta-icon"></span> : <span className="collapse-down-icon icon-large text-cta-icon"></span>}
                            </span>
                          </div>
                          <div className={`collapse ${openSection === section ? "show" : ""}`}>

                            {partElements.map((field, fieldIndex) => {

                              return(
                              <React.Fragment key={`part-${index}-${fieldIndex}`}>
                                <span className="group-label" key={`${index}-${fieldIndex}`}>{field.partName}</span>
                                <div className="custom-row" key={fieldIndex}>
                                  {field.dimensions && Object.keys(field.dimensions).map((dimensionKey, dimensionIndex) => {
                                    if (dimensionKey === "bedding") return null; // Skip the bedding dimension
                                    const trad_key = dimensionKey === "height1" ? field.dimensions["height2"].displayDistinct === false ? "config3d_custom_pieces_modal_parts_height" : "config3d_custom_pieces_modal_parts_height1" : `config3d_custom_pieces_modal_parts_${dimensionKey}`;
                                    if (field.dimensions[dimensionKey].displayDistinct === undefined || field.dimensions[dimensionKey].displayDistinct === true) {
                                      return <CustomInputNumber
                                        key={`${fieldIndex}-${dimensionIndex}`}
                                        fieldData={field.dimensions[dimensionKey]}
                                        label={t(trad_key)}
                                        value={field.dimensions[dimensionKey].userValue}
                                        onValueChange={(newValue) =>
                                          handleDimensionValueChange(index, fieldIndex, dimensionKey, newValue)
                                        }
                                        autoSelect={true}
                                      />
                                    }
                                  })}
                                </div>
                              </React.Fragment>
                              )
                            })}

                          </div>
                        </div>
                      );
                    })}
                  </>
                }
                {loadIconSecondStep && !productConfigError && <div className="spinner-border second-step" role="status" />}
              </div>
            </div>
          </div>
        </div>


        <div className="CustomPartsImage">
          {imageSvg && <>
            <div
              className="CustomPartsImageContent"
              dangerouslySetInnerHTML={{ __html: imageSvg }}
            />
            <p className="CustomPartsImageCaption">
              {t("config3d_custom_pieces_modal_image_caption")}
            </p>
          </>}
          
        </div>
      </div>

      <div className="Footer border-color-top">
        <button id="cancelBtn" className="button-secondary button-medium text-dark cancel" onClick={props.onModalClose} disabled={loadIcon}>
          <span>{t("config3d_custom_pieces_modal_cancel_button")}</span>
        </button>
        <button id="validateBtn"
          className="button-primary button-medium text-cta float-right Order" disabled={step !== 2 || loadValidIcon} onClick={handleValidate}>
          {loadValidIcon && <div className="spinner-border valid" role="status" />}
          {!loadValidIcon &&<span className="true-icon icon-large text-cta-icon"></span>}
          <div>{t("config3d_custom_pieces_modal_validate_button")}</div>
        </button>
      </div>
    </div>
  )
}

export const ModalConfigurationDescription = connect(
  state => ({
    canChangePrice: true,
    ui: state.ui,
    user: state.user,
    monumentLayout: state.configurator.current.configuration.monument.layout,
    configDeformable: state.configurator.current.configuration.deformable,
    configurator: state.configurator,
    layouts: state.configurator.current.options.layouts,
    layoutsBaseHeights: state.configurator.current.options.layoutsBaseHeights,
    deformableUpdateSuccess: state.configurator.deformableUpdateSuccess,
    ...state.configurator.current
  }),

  dispatch => ({
    actions: bindActionCreators(updateConfigurationActions, dispatch),
    uiActions: bindActionCreators(uiActions, dispatch)
  })

)(ModalConfigurationDescriptionComponent);